import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row q-gutter-sm q-my-sm" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = {
  key: 0,
  class: "row q-gutter-sm q-my-sm"
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row q-gutter-sm q-my-sm" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row q-gutter-sm q-my-sm" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = {
  key: 1,
  class: "row q-gutter-sm q-my-sm"
}
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 3,
  class: "row q-gutter-sm q-my-sm"
}
const _hoisted_13 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_FormChildTimer = _resolveComponent("FormChildTimer")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_ModalPromptDelete = _resolveComponent("ModalPromptDelete")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (typeof _ctx.typeOptions !== 'undefined')
              ? (_openBlock(), _createBlock(_component_q_select, {
                  key: 0,
                  filled: "",
                  ref: "typeRef",
                  "reactive-rules": true,
                  rules: [(val) => !!val || _ctx.formLabel('requiredGeneric')],
                  modelValue: _ctx.typeOption,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.typeOption) = $event)),
                  options: _ctx.typeOptions,
                  color: "accent",
                  label: _ctx.formLabel('type'),
                  behavior: "menu"
                }, {
                  "selected-item": _withCtx(({ opt }) => [
                    opt
                      ? (_openBlock(), _createBlock(_component_q_item, {
                          key: 0,
                          dense: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.formOption(opt)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  option: _withCtx(({ index: optionIndex, opt }) => [
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      onClick: ($event: any) => (_ctx.typeOption = _ctx.typeOptions[optionIndex])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formOption(opt)), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                }, 8, ["rules", "modelValue", "options", "label"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.activityType == 'team' && _ctx.typeOption == 'merch')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_q_input, {
                  ref: "jobRef",
                  modelValue: _ctx.job,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.job) = $event)),
                  color: "accent",
                  filled: "",
                  type: "text",
                  rules: [(val) => !!val || _ctx.formLabel('requiredGeneric')],
                  mask: "######",
                  label: _ctx.formLabel('job')
                }, null, 8, ["modelValue", "rules", "label"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_q_input, {
                  ref: "waveRef",
                  modelValue: _ctx.wave,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.wave) = $event)),
                  color: "accent",
                  filled: "",
                  type: "text",
                  rules: [(val) => !!val || _ctx.formLabel('requiredGeneric')],
                  mask: "###",
                  label: _ctx.formLabel('wave')
                }, null, 8, ["modelValue", "rules", "label"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (typeof _ctx.locationOptions !== 'undefined')
              ? (_openBlock(), _createBlock(_component_q_select, {
                  key: 0,
                  filled: "",
                  ref: "locationRef",
                  "reactive-rules": true,
                  rules: [(val) => !!val || _ctx.formLabel('requiredGeneric')],
                  modelValue: _ctx.locationOption,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.locationOption) = $event)),
                  options: _ctx.locationOptions,
                  color: "accent",
                  label: _ctx.formLabel('location'),
                  behavior: "menu"
                }, {
                  "selected-item": _withCtx(({ opt }) => [
                    opt
                      ? (_openBlock(), _createBlock(_component_q_item, {
                          key: 0,
                          dense: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.formOption(opt)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  option: _withCtx(({ index: optionIndex, opt }) => [
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      onClick: ($event: any) => (_ctx.locationOption = _ctx.locationOptions[optionIndex])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formOption(opt)), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                }, 8, ["rules", "modelValue", "options", "label"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_q_input, {
              ref: "startRef",
              "model-value": 
            _ctx.useFormatDate(_ctx.start).time({
              hour: 'numeric',
              minute: 'numeric',
              hourCycle: 'h23',
            })
          ,
              rules: [
            (val) => _ctx.isValidDate(val) || '',
            (val) => _ctx.rules.beforeNow(_ctx.toDate(val, _ctx.date)) || _ctx.formLabel('notBeforeNow'),
            (val) => _ctx.rules.beforeEnd(_ctx.toDate(val, _ctx.date)) || _ctx.formLabel('startOverlapEnd'),
            (val) => _ctx.rules.notBetweenTimers(_ctx.toDate(val, _ctx.date), _ctx.index) || _ctx.formLabel('betweenActivities'),
            (val) =>
              _ctx.rules.notOverlap(_ctx.toDate(val, _ctx.date), 'start', _ctx.index) || _ctx.formLabel('overlapActivities'),
            (val) =>
              _ctx.useChildTimerRules().sumChildrenNotGreaterThanParent(
                { newEnd: _ctx.end, newStart: _ctx.toDate(val, _ctx.date) as Date },
                _ctx.timer
              ) || _ctx.formLabel('childrenSum'),
          ],
              "onUpdate:modelValue": _cache[4] || (_cache[4] = (val) => (_ctx.isValidDate(val) ? _ctx.updateStart(_ctx.toDate(val, _ctx.date) as Date) : undefined)),
              color: "accent",
              filled: "",
              type: "time",
              label: _ctx.formLabel('startTime')
            }, null, 8, ["model-value", "rules", "label"])
          ])
        ]),
        ((!_ctx.editing && (_ctx.endState || _ctx.insert)) || (_ctx.editing && _ctx.endState))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_q_input, {
                  ref: "endRef",
                  "model-value": 
            _ctx.useFormatDate(_ctx.end).time({
              hour: 'numeric',
              minute: 'numeric',
              hourCycle: 'h23',
            })
          ,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = (val) => (_ctx.isValidDate(val) ? _ctx.updateEnd(_ctx.toDate(val, _ctx.date) as Date) : undefined)),
                  rules: [
            (val) => _ctx.isValidDate(val),
            (val) => _ctx.rules.beforeNow(_ctx.toDate(val, _ctx.date)) || _ctx.formLabel('notBeforeNow'),
            (val) => _ctx.rules.afterStart(_ctx.toDate(val, _ctx.date)) || _ctx.formLabel('endOverlapStart'),
            (val) => _ctx.rules.notOverlap(_ctx.toDate(val, _ctx.date), 'end', _ctx.index) || _ctx.formLabel('overlapActivities'),
            (val) => _ctx.rules.notBetweenTimers(_ctx.toDate(val, _ctx.date), _ctx.index) || _ctx.formLabel('betweenActivities'),
            (val) =>
              _ctx.useChildTimerRules().sumChildrenNotGreaterThanParent(
                { newStart: _ctx.start, newEnd: _ctx.toDate(val, _ctx.date) as Date },
                _ctx.timer
              ) || _ctx.formLabel('childrenSum'),
          ],
                  color: "accent",
                  filled: "",
                  type: "time",
                  label: _ctx.formLabel('endTime')
                }, null, 8, ["model-value", "rules", "label"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasChildTimer && typeof _ctx.index === 'number')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_q_btn, {
                flat: "",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showChildModal = true)),
                label: _ctx.formLabel('updateLastTask')
              }, null, 8, ["label"]),
              _createVNode(_component_FormChildTimer, {
                modelValue: _ctx.showChildModal,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showChildModal) = $event)),
                timer: _ctx.timer,
                "parent-index": _ctx.index
              }, null, 8, ["modelValue", "timer", "parent-index"])
            ], 64))
          : _createCommentVNode("", true),
        (!_ctx.editing && (_ctx.endState || _ctx.insert))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_q_input, {
                  filled: "",
                  "bg-color": "white",
                  color: "accent",
                  "model-value": _ctx.duration,
                  readonly: "",
                  label: _ctx.formLabel('duration')
                }, null, 8, ["model-value", "label"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_q_card_actions, {
      align: "right",
      class: "text-primary"
    }, {
      default: _withCtx(() => [
        (!_ctx.endState && !_ctx.editing)
          ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              flat: "",
              onClick: _ctx.close,
              label: _ctx.formLabel('close')
            }, null, 8, ["onClick", "label"])), [
              [_directive_close_popup]
            ])
          : _createCommentVNode("", true),
        (!_ctx.endState && !_ctx.editing)
          ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
              key: 1,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.actionAdd(_ctx.activityType))),
              color: "primary",
              label: _ctx.formLabel('start')
            }, null, 8, ["label"])), [
              [_directive_close_popup, 
        !!(
          _ctx.rules.beforeNow(_ctx.start) &&
          (typeof _ctx.locationOptions === 'undefined' ||
            (typeof _ctx.locationOptions !== 'undefined' && typeof _ctx.locationOption !== 'undefined'))
        ) || false
      ]
            ])
          : _createCommentVNode("", true),
        (_ctx.endState && !_ctx.insert)
          ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
              key: 2,
              color: "primary",
              split: "",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.save(_ctx.activityType))),
              label: _ctx.formLabel('stopSave')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, null, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      onClick: _ctx.removeActivity
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formLabel('delete')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]))
          : (_ctx.endState && _ctx.insert && !_ctx.editing)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.formLabel('cancel')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup, 2]
                ]),
                _createVNode(_component_q_btn, {
                  color: "primary",
                  split: "",
                  onClick: _ctx.insertActivity,
                  label: _ctx.formLabel('saveNewActivity')
                }, null, 8, ["onClick", "label"])
              ], 64))
            : (_ctx.editing)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formLabel('cancel')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_close_popup, 2]
                  ]),
                  (_ctx.activityType == 'store')
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        color: "primary",
                        onClick: _ctx.editActivity,
                        label: `${_ctx.formLabel('save')} ${_ctx.activityLabel(_ctx.activityType)}`
                      }, null, 8, ["onClick", "label"]))
                    : _createCommentVNode("", true),
                  (_ctx.activityType != 'store')
                    ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                        key: 1,
                        color: "primary",
                        split: "",
                        onClick: _ctx.editActivity,
                        label: `${_ctx.formLabel('save')} ${_ctx.activityLabel(_ctx.activityType)}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_list, null, {
                            default: _withCtx(() => [
                              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                clickable: "",
                                onClick: _ctx.promptRemoveActivity
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.formLabel('delete')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick", "label"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ModalPromptDelete, {
      modelValue: _ctx.modalPromptDelete,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalPromptDelete) = $event)),
      onConfirmDelete: _ctx.removeActivity
    }, null, 8, ["modelValue", "onConfirmDelete"])
  ], 64))
}